import { NavLink } from "react-router-dom";
import { ArrowUpRightRegular } from "@fluentui/react-icons";
import { navigation } from "../navigation";

export const Sidenav = ({ onNavigate, poolListHref = "/pools" }) => (
    <div className="sidebar-content">
        <NavLink to="/" className="brand" onClick={onNavigate} aria-label="EzFunc home">
            <span className="brand-mark" aria-hidden="true">ez<span>/</span></span>
            <span>EzFunc<small>Engineering systems</small></span>
        </NavLink>
        <nav aria-label="Main navigation" className="sidenav-nav">
            {["Workspace", "Operations", "Insights"].map(group => (
                <div className="nav-group" key={group}>
                    <p className="nav-group-label">{group}</p>
                    {navigation.filter(item => item.group === group).map(({ path, label, icon: Icon }) => (
                        <NavLink key={path} to={path === "/pools" ? poolListHref : path} end={path === "/"} onClick={onNavigate}
                            className={({ isActive }) => `nav-link${isActive ? " nav-link--active" : ""}`}>
                            <Icon /><span>{label}</span>
                        </NavLink>
                    ))}
                </div>
            ))}
        </nav>
        <div className="sidebar-footer">
            <a href="https://dev.azure.com/powerbi/MWC/_git/ez-func" target="_blank" rel="noreferrer">
                Source & documentation <ArrowUpRightRegular />
            </a>
            <p>MWC / ENGINEERING SYSTEMS</p>
        </div>
    </div>
);
